export default __webpack_public_path__ + "static/media/undraw08.2b2b1dcb.svg";